import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { ContractListComponent, PlaceholderCardComponent, PageHeaderComponent } from '../../components';
import { ContractsService } from '../../contracts.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import { CustomerService } from '@core';

interface DashboardViewCard {
    title: string;
    route: string[] | string;
    class: string;
    icon: string;
}

@Component({
    selector: 'app-dashboard-view',
    imports: [
        CtrlIconComponent,
        NgClass,
        RouterModule,
        CommonModule,
        ContractListComponent,
        PlaceholderCardComponent,
        PageHeaderComponent,
    ],
    templateUrl: './dashboard-view.component.html',
    styleUrl: './dashboard-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardViewComponent implements OnInit {
    public cards: DashboardViewCard[] = [
        { title: 'Mein Kundenkonto', route: ['/', 'portal', 'mein-kundenkonto'], class: 'bg:blue-1', icon: 'account' },
        {
            title: 'Schaden&nbsp;melden&nbsp;/ Rechnung&nbsp;einreichen',
            route: ['/', 'portal', 'schaden-melden'],
            class: 'bg:blue-2',
            icon: 'damage_big',
        },
        {
            title: 'Bezahlmethode',
            route: ['/', 'portal', 'vertrag-waehlen-fuer-bezahlmethoden'],
            class: 'bg:blue-4',
            icon: 'credit_card_big',
        },
    ];

    private contractsService = inject(ContractsService);
    protected customer = toSignal(inject(CustomerService).customer$);

    protected contractsPending = signal(true);
    protected contracts = toSignal(this.contractsService.contracts$);

    public ngOnInit(): void {
        this.contractsService
            .fetch()
            .pipe(
                tap(() => {
                    this.contractsPending.set(false);
                }),
            )
            .subscribe();
    }
}
